import { formatDate } from '../../../../common/helpers'

const _legacyOldWageContract = {
  "amount": 7.25,
  "id": "5d5f2a2b4ace07568cbc58d6",
  "jurisdiction": "federal",
  "jurisdictionName": "Federal"
}

/**
 * Yes this is awful side-effect coding that writes to the wages arg. This whole thing is awful and deprecated on arrival.
 */
const assignCurrentWages = (wages, wagesByJurisdiction, tipped) => {
  if (wages['wage rate'] && wages['wage rate'].new) {
    switch (wages['wage rate'].new.jurisdiction) {
      case 'state':
        wages['wage rate'].old = {
          amount: wagesByJurisdiction.US.states[wages['wage rate'].new.state]
            && wagesByJurisdiction.US.states[wages['wage rate'].new.state].wages['wage rate']
            && wagesByJurisdiction.US.states[wages['wage rate'].new.state].wages['wage rate'].wage,
          jurisdiction: wages['wage rate'].new.jurisdiction,
          jurisdictionName: wages['wage rate'].new.jurisdictionName
        }
        break
      case 'county':
        wages['wage rate'].old = {
          amount: wagesByJurisdiction.US.states[wages['wage rate'].new.state].counties[wages['wage rate'].new.jurisdictionName]
            && wagesByJurisdiction.US.states[wages['wage rate'].new.state].counties[wages['wage rate'].new.jurisdictionName].wages['wage rate']
            && wagesByJurisdiction.US.states[wages['wage rate'].new.state].counties[wages['wage rate'].new.jurisdictionName].wages['wage rate'].wage,
          jurisdiction: wages['wage rate'].new.jurisdiction,
          jurisdictionName: wages['wage rate'].new.jurisdictionName
        }
        break
      case 'city':
        wages['wage rate'].old = {
          amount: wagesByJurisdiction.US.states[wages['wage rate'].new.state].cities[wages['wage rate'].new.jurisdictionName]
            && wagesByJurisdiction.US.states[wages['wage rate'].new.state].cities[wages['wage rate'].new.jurisdictionName].wages['wage rate']
            && wagesByJurisdiction.US.states[wages['wage rate'].new.state].cities[wages['wage rate'].new.jurisdictionName].wages['wage rate'].wage,
          jurisdiction: wages['wage rate'].new.jurisdiction,
          jurisdictionName: wages['wage rate'].new.jurisdictionName
        }
        break
      case 'federal':
        wages['wage rage'].old = {
          amount: wagesByJurisdiction.US.wages['wage rate'].wage,
          jurisdiction: wages['wage rate'].new.jurisdiction,
          jurisdictionName: wages['wage rate'].new.jurisdictionName
        }
        break
      default:
        console.warn('unexpected jurisdiction type in notification mapping')
    }
  }

  if (tipped && wages.gratuities && wages.gratuities.new) {
    switch (wages.gratuities.new.jurisdiction) {
      case 'state':
        wages.gratuities.old = {
          amount: wagesByJurisdiction.US.states[wages.gratuities.new.state]
            && wagesByJurisdiction.US.states[wages.gratuities.new.state].wages.gratuities
            && wagesByJurisdiction.US.states[wages.gratuities.new.state].wages.gratuities.wage,
          jurisdiction: wages.gratuities.new.jurisdiction,
          jurisdictionName: wages.gratuities.new.jurisdictionName
        }
        break
      case 'county':
        wages.gratuities.old = {
          amount: wagesByJurisdiction.US.states[wages.gratuities.new.state].counties[wages.gratuities.new.jurisdictionName]
            && wagesByJurisdiction.US.states[wages.gratuities.new.state].counties[wages.gratuities.new.jurisdictionName].wages.gratuities
            && wagesByJurisdiction.US.states[wages.gratuities.new.state].counties[wages.gratuities.new.jurisdictionName].wages.gratuities.wage,
          jurisdiction: wages.gratuities.new.jurisdiction,
          jurisdictionName: wages.gratuities.new.jurisdictionName
        }
        break
      case 'city':
        wages.gratuities.old = {
          amount: wagesByJurisdiction.US.states[wages.gratuities.new.state].cities[wages.gratuities.new.jurisdictionName]
            && wagesByJurisdiction.US.states[wages.gratuities.new.state].cities[wages.gratuities.new.jurisdictionName].wages.gratuities
          && wagesByJurisdiction.US.states[wages.gratuities.new.state].cities[wages.gratuities.new.jurisdictionName].wages.gratuities.wage,
          jurisdiction: wages.gratuities.new.jurisdiction,
          jurisdictionName: wages.gratuities.new.jurisdictionName
        }
        break
      case 'federal':
        wages.gratuities.old = {
          amount: wagesByJurisdiction.US.wages.gratuities.wage,
          jurisdiction: wages.gratuities.new.jurisdiction,
          jurisdictionName: wages.gratuities.new.jurisdictionName
        }
        break
      default:
        console.warn('unexpected jurisdiction type in notification mapping')
    }
  }
}

const mapNotifications = (tipped, notifications, locations, wagesByJurisdiction) => notifications.map((notification) => {
  const laws = []

  if (notification.wages['wage rate'] && notification.wages['wage rate'].new) {
    laws.push(notification.wages['wage rate'].new.law)
  }

  if (notification.wages.gratuities && notification.wages.gratuities.new) {
    laws.push(notification.wages.gratuities.new.law)
  }

  if (wagesByJurisdiction) {
    assignCurrentWages(notification.wages, wagesByJurisdiction, tipped)
  }

  return {
    notificationDate: formatDate(notification.date),
    locations: notification.locations.length,
    locationsData: Object.values(locations).filter((location) => notification.locations.includes(location.id)),
    law: laws.join(', '),
    tipped,
    wages: notification.wages,
    notificationNewWage: notification.wages['wage rate'] && notification.wages['wage rate'].new,
    notificationPrevailingWage: notification.wages['wage rate'] && notification.wages['wage rate'].old && notification.wages['wage rate'].new ? notification.wages['wage rate'].old : null,
    notificationNewTipWage: tipped && notification.wages.gratuities && notification.wages.gratuities.new,
    notificationPrevailingTipWage: tipped && notification.wages.gratuities && notification.wages.gratuities.old && notification.wages.gratuities.new ? notification.wages.gratuities.old : null,
    name: extractAnyJurisdictionNameFromNotification(notification),
    jurisdictionType: extractAnyJurisdictionTypeFromNotification(notification)
  }
})

const extractAnyJurisdictionNameFromNotification = (notification) => {
  const oldNonTippedJurisdictionName = (notification.wages['wage rate'] && notification.wages['wage rate'].old)
    ? notification.wages['wage rate'].old.jurisdictionName
    : ''
  const newNonTippedJurisdictionName = (notification.wages['wage rate'] && notification.wages['wage rate'].new)
    ? notification.wages['wage rate'].new.jurisdictionName
    : ''
  const oldTippedJurisdictionName = (notification.wages.gratuities && notification.wages.gratuities.old)
    ? notification.wages.gratuities.old.jurisdictionName
    : ''
  const newTippedJurisdictionName = (notification.wages.gratuities && notification.wages.gratuities.new)
    ? notification.wages.gratuities.new.jurisdictionName
    : ''

  return oldNonTippedJurisdictionName
  || newNonTippedJurisdictionName
  || oldTippedJurisdictionName
  || newTippedJurisdictionName
}

const extractAnyJurisdictionTypeFromNotification = (notification) => {
  const oldNonTippedJurisdictionType = (notification.wages['wage rate'] && notification.wages['wage rate'].old)
    ? notification.wages['wage rate'].old.jurisdiction
    : ''
  const newNonTippedJurisdictionType = (notification.wages['wage rate'] && notification.wages['wage rate'].new)
    ? notification.wages['wage rate'].new.jurisdiction
    : ''
  const oldTippedJurisdictionType = (notification.wages.gratuities && notification.wages.gratuities.old)
    ? notification.wages.gratuities.old.jurisdiction
    : ''
  const newTippedJurisdictionType = (notification.wages.gratuities && notification.wages.gratuities.new)
    ? notification.wages.gratuities.new.jurisdiction
    : ''

  return oldNonTippedJurisdictionType
    || newNonTippedJurisdictionType
    || oldTippedJurisdictionType
    || newTippedJurisdictionType
}

export default mapNotifications
